import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 35,
		height: 35,
		rx: 3,
		fill: "#15202B",
		stroke: "#9C7B3F"
	}), /* @__PURE__ */ _jsx("text", {
		x: 18,
		y: 24,
		textAnchor: "middle",
		fontFamily: "Newsreader, Georgia, serif",
		fontSize: 17,
		fontWeight: 500,
		fill: "#EFE7D6",
		children: "QG"
	})]
});
export default SvgLogoIcon;
